module.exports = __webpack_public_path__ + "static/img/btn_shop.2ebbb254.png";